<template>
  <div class="bg-white">
    <div class="app-body">
      <nav class="navbar navbar-expand-lg navbar-light bg-white">
        <a class="navbar-brand" :href="rootPath">
          <img :src="assetsPath +'static/images/logo.jpg'" style="max-width:100%">
        </a>
        <!-- <div v-if="userinfo.id || stuinfo.id" class="userinfo-logout">
          <a href="javascript:;" @click="logout"><i class="el-icon-circle-close"></i>退出登录</a>
        </div> -->
        <button class="navbar-toggler" type="button" @click="mshow = !mshow">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" :class="{'show': mshow}">
          <div class="ml-auto d-flex align-items-center">
            <!-- {{userinfo}} -->
            <div v-if="isStu && userinfo.id && userinfo.type == 4" class="userinfo-toggle">
              <a href="javascript:;" @click="toTeacher"><i class="el-icon-sort"></i>切换教师账户</a>
            </div>
            <div v-if="!isStu && stuinfo.id" class="userinfo-toggle">
              <a href="javascript:;" @click="toStu"><i class="el-icon-sort"></i>切换个人账户</a>
            </div>
            <!-- {{isStu}} / {{isStu && userinfo.id && userinfo.type == 4}} -->
            <!-- {{ userinfo }}
            {{ stuinfo }} -->
            <div v-if="!$scopedSlots.right" class="userinfo">
              <img :src="headPic">
              <el-dropdown class="ml-2" @command="doCommand">
                <span class="el-dropdown-link">
                  <div class="mr-1">
                    <div class="organizationname">{{ userinfo.organizationname || '' }}</div>
                    <div class="username" >{{ (isStu ? stuinfo.name : userinfo.name) || '请登录' }}</div>
                  </div>
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-if="userinfo.id || stuinfo.id" icon="el-icon-user" command="info">账号详情</el-dropdown-item>
                  <el-dropdown-item v-if="userinfo.id || stuinfo.id" icon="el-icon-circle-close" command="logout">退出登录</el-dropdown-item>
                  <el-dropdown-item v-if="!(userinfo.id || stuinfo.id)" icon="el-icon-circle-close" command="login">登录</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <div>
                
              </div>
            </div>
          </div>
        </div>
      </nav>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import tools from '@/utils/tools';
export default {
  name: 'AppHeader',
  mixins: [tools],
  props: {
    info: String,
    logout: Function
  },
  data() {
    return {
      mshow: false,
    }
  },
  computed: {
    ...mapState(['utype']),
    isStu() {
      return this.utype == 'stu';
    }
  },
  methods: {
    getData() {
    },
    doCommand(command) {
      if (command == 'info') {
        this.$router.push(this.info);
      } else if (command == 'logout') {
        this.logout();
      } else if (command == 'login') {
        location.href = this.rootPath + 'login?url='+ encodeURI(location.href);
      }
    },
    toTeacher() {
      // console.log('toTeacher')
      // console.log(this.userinfo)
      this.$router.replace('/teacher-main');
    },
    toStu() {
      // console.log('toStu')
      // console.log(this.stuinfo)
      this.$router.replace('/stu-main');
    }
  }
}
</script>
<style lang="less" scoped>
.userinfo {
  .flex-center();
  &-logout {
    margin-top: 10px;
    margin-left: auto;
    a {
      color: #834848;
    }
  }
  &-toggle {
    margin-right: 2rem;
  }
  img {
    height:3rem;
  }
  .el-dropdown-link {
    .flex-center-v();
    font-size:1rem;
    color:#222;
    .organizationname {
      color:#000;
    }
    .username {
      color:#ff6600;
    }
  }
}
.navbar-toggler {
  position: absolute;
  top: 50%;
  right: 2rem;
  z-index: 999;
  color: #000;
  background-color: rgba(255,255,255,1);
  transform: translateY(-50%);
}
@media screen and (min-width: 992px) {
  .userinfo {
    &-logout {
      display: none;
    }
  }
}
</style>